import { render, staticRenderFns } from "./NavbarSdpi.vue?vue&type=template&id=52a53b6c&scoped=true"
import script from "./NavbarSdpi.vue?vue&type=script&lang=js"
export * from "./NavbarSdpi.vue?vue&type=script&lang=js"
import style0 from "./NavbarSdpi.vue?vue&type=style&index=0&id=52a53b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a53b6c",
  null
  
)

export default component.exports